import { type FunctionComponent, useState } from 'react';

import MessageModal from 'components/admin/MessageModal';

type PropsT = {
  onCancel: () => void;
  onRemove: () => Promise<void>;
};

// TODO: It is almost the same as <RemoveVideoModal>,
// we should merge two together... say <RemoveModal>?
const RemovePractitionerModal: FunctionComponent<PropsT> = ({
  onCancel,
  onRemove,
}) => {
  const [busy, setBusy] = useState(false);
  return (
    <MessageModal
      busy={busy}
      cancelButtonLabel="No, cancel"
      confirmButtonLabel="Yes, remove"
      icon="WARN"
      onCancel={onCancel}
      onConfirm={() => {
        void (async () => {
          try {
            setBusy(true);
            await onRemove();
          } catch {
            // TODO: We need an in-app error modal!
            // eslint-disable-next-line no-alert
            alert('Failed to change practitioner status');
          } finally {
            setBusy(false);
          }
        })();
      }}
    >
      <h1>Are you sure you want to remove this practitioner?</h1>
      <p>
        This action cannot be undone. If you remove a practitioner, you’ll
        need to send a new invitation to reactivate them.
      </p>
    </MessageModal>
  );
};

export default RemovePractitionerModal;
